import React from "react";
import Layout from "../layouts/index";
import Home from "../screens/Info/Home";

const BecomeADriverPage = () => {
  return (
    <Layout>
      <Home />
    </Layout>
  );
};

export default BecomeADriverPage;
